import { useLazyQuery } from '@apollo/client';
import { enqueueSnackbar } from 'notistack';
import { useEffect } from 'react';

import { gql } from '../../generated';

import { useUser } from './auth/use-user';

const GET_MERCHANT = gql(/* GraphQL */ `
  query GET_MERCHANT {
    merchant {
      mass_withdraw_enabled
      withdraw_enabled
      refund_enabled
    }
  }
`);

export const useMerchant = () => {
  const { isAuth } = useUser();

  const [, { loading, data, refetch }] = useLazyQuery(GET_MERCHANT, {
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: 'error' });
    },
  });

  useEffect(() => {
    if (isAuth) {
      refetch();
    }
  }, [isAuth, refetch]);

  return {
    loading,
    merchant: data?.merchant[0],
  };
};
